import { gql } from "@apollo/client";

export const GET_DATOS_GENERALES_RESUMEN = gql`
  query DatosGeneralesResumenRIByID (
    $idDatosGenerales: Int!
  ){
    datosGeneralesResumenRIByID (
      idDatosGenerales: $idDatosGenerales
    ){
      datosGeneralesRINavigation{
        centroReferencia
        codInstitucionReferenciaNavigation{
          nombre
        }
        idComboRIValorLugarServicioNavigation{
          valor
        }
        idComboRIValorLugarRINavigation{
          valor
        }
        servicioEmergencia
        telefonoEmergencia
        tipoModuloRI{
          idTipoModulo
          idTipoModuloNavigation{
            abreviacion
          }
        }
        resumenHCL
        diagnosticoAlta
        diagnosticoRI{
          idItemDiagnosticoNavigation{
            descripcion
          }
        }
        enfermedadOncologica
        antecedenteClinicoRI{
          idComboRIValorNavigation{
            valor
          }
        }
        otrosAntecedentes
        comentarioRelevante
        alergiaRI{
          idAlergiaNavigation{
            descripcion
          }
        }
        otrasAlergias
        medicacionHabitual
        estableHemodinamicamente
        estableEnfermedad
        nivelConciencia
        escaras
        ostomias
        otrosRelevantes
        pesoActual
        talla
        idComboRIValorNivelActividadNavigation{
          valor
        }
        idComboRIValorAduPerdidaPesoNavigation{
          valor
        }
        aduPesoHabitual
        idComboRIValorAduEvaluadoNavigation{
          valor
        }
        aduIMC
        aduPerdidaPeso
        idComboRIValorAduGradoDesnutricionNavigation{
          valor
        }
        idComboRIValorAduDiagnosticoNutricionalNavigation{
          valor
        }
        idComboRIValorAduMetaNutricionalNavigation{
          valor
        }
        pedCircunferenciaMBraquial
        pedZScoreTalla
        pedZScorePeso
        pedZScoreIMC
        idComboRIValorPedDiagnosticoNutricionalNavigation{
          valor
        }
        idComboRIValorPedMetaSoporteNutricionalNavigation{
          valor
        }
        requerimientosExtraNutricionalesRI{
          idComboRIValorNavigation{
            valor
          }
        }
        justificacionSoporteRI{
          idComboRIValorNavigation{
            valor
          }
        }
      }
      datosFiliatorios{
        hC
        nombre
        apellido
        dNI
        fechaNacimiento
        edad
        sexo
        domicilio
        financiador
        nroAfiliado
        telContacto
        familiarContacto
        telFamiliar
        medicoPrescriptor
      }
    }
  }
`;